import { Redirect, Route, RouteProps } from 'react-router';

// eslint-disable-next-line
import React, { FC, ComponentType } from 'react';
import { selectLoggedUser } from 'store/modules/auth';
import { useUserRole } from 'core/auth/hooks';
import { useSelector } from 'react-redux';
import { Roles } from './user.model';

type PrivateRouteProps = {
  component: ComponentType<any>;
  requiredRoles?: Roles[];
  redirectPath?: string;
} & RouteProps;

const PrivateRoute: FC<PrivateRouteProps> = ({
  component: Component,
  requiredRoles = [],
  redirectPath = '/login',
  ...rest
}) => {
  const user = useSelector(selectLoggedUser);
  const isAuthorized = useUserRole(requiredRoles);

  const showRoute = () => {
    if (user) {
      if (requiredRoles.length === 0 || isAuthorized) {
        return true;
      }
      return false;
    }
    return false;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        showRoute() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
